adjust_death_adt_values = (cover, coberturas) => {
  cover.monthly = parseFloat(cover.valorCapital) * parseFloat(cover.tax);

  const outrasCoberturasSum = coberturas
    .filter((x) => x.order > 1 && x.valorCapital > 0)
    .reduce((n, { monthly }) => n + monthly, 0);
  if (outrasCoberturasSum + cover.monthly < 30) {
    cover.monthly = 30 - outrasCoberturasSum;
    cover.valorCapital = Math.round(cover.monthly / parseFloat(cover.tax), 2);
  }
};

module.exports = {
  adjust_death_adt_values,
};
